module.exports = __webpack_public_path__ + "static/media/instructor.d80d7e05.png";